module.exports = __webpack_public_path__ + "static/media/iconCanvas12.40d61706.svg";